import { render } from "./globaldialog.vue?vue&type=template&id=4e1c2c1f"
import script from "./globaldialog.vue?vue&type=script&lang=js"
export * from "./globaldialog.vue?vue&type=script&lang=js"

import "./globaldialog.vue?vue&type=style&index=0&id=4e1c2c1f&lang=less"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__